export default __webpack_public_path__ + "static/media/MoveCardIcon.2e01403b.svg";